import { Button, Stack } from '@lyearn/ui';

import { DialogFooterProps } from '../DialogFooter/types';

const DialogFullWidthFooter = (props: DialogFooterProps) => {
  const {
    className = 'p-24',
    autoFocus = true,
    buttonSize = 'large',
    gapX = 8,
    primaryAction,
    secondaryAction,
  } = props;

  return (
    <Stack className={className} direction="row-reverse" gapX={gapX}>
      <Button fullWidth autoFocus={autoFocus} shape="pill" size={buttonSize} {...primaryAction}>
        {primaryAction.label}
      </Button>
      {secondaryAction ? (
        <Button
          fullWidth
          appearance="secondary"
          shape="pill"
          size={buttonSize}
          variant="outlined"
          {...secondaryAction}>
          {secondaryAction.label}
        </Button>
      ) : null}
    </Stack>
  );
};

export default DialogFullWidthFooter;
